/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

"use client";

import React, { memo } from "react";

interface AppStoreInitializerProps {
  children: React.ReactNode;
}

/**
 * Initializer component for app store setup.
 * Organization sync is now handled by OrganizationSyncProvider.
 */
const AppStoreInitializerComponent = ({
  children,
}: AppStoreInitializerProps) => {
  return <>{children}</>;
};

export const AppStoreInitializer = memo(AppStoreInitializerComponent);
